"use client";

import { IconContext } from "@phosphor-icons/react";

/**
 * `@phosphor-icons/react` uses React context under the hood.
 * This must run in a Client Component to avoid SSR errors.
 */
export function PhosphorIconContextProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <IconContext.Provider value={{ color: "currentColor", weight: "duotone" }}>
      {children}
    </IconContext.Provider>
  );
}

